import { isDrawingEnabledForPreloading } from './DrawingUtils';

class ExcalidrawPreloadService {
    isPreloaded = false;
    preloadPromise = null;
    preloadedComponent = null;
    preloadedExportToCanvas = null;
    preloadedSerializeAsJSON = null;
    preloadedLanguages = null;
    preloadedDefaultLang = null;

    hasDrawingInteractions(assessment) {
        if (!assessment?.sections) {
            return false;
        }

        return assessment.sections.some((section) => {
            if (!section?.questions) {
                return false;
            }

            return section.questions.some((question) => {
                return isDrawingEnabledForPreloading(question);
            });
        });
    }

    async preloadExcalidrawIfNeeded(assessment) {
        if (this.isPreloaded) {
            return this.preloadedComponent;
        }

        if (this.preloadPromise) {
            await this.preloadPromise;
            return this.preloadedComponent;
        }

        if (!this.hasDrawingInteractions(assessment)) {
            return null;
        }

        this.preloadPromise = this.preloadExcalidraw();

        try {
            this.preloadedComponent = await this.preloadPromise;
            this.isPreloaded = true;
            return this.preloadedComponent;
        } catch (error) {
            this.preloadPromise = null;
            this.preloadedComponent = null;
            throw error;
        }
    }

    async preloadExcalidraw() {
        const { default: LazyExcalidrawComponent, exportToCanvas, serializeAsJSON, languages, defaultLang } = await import(
            /* webpackChunkName: "lazy-excalidraw" */
            '../components/question/LazyExcalidrawComponent'
        );

        this.preloadedExportToCanvas = exportToCanvas;
        this.preloadedSerializeAsJSON = serializeAsJSON;
        this.preloadedLanguages = languages;
        this.preloadedDefaultLang = defaultLang;
        return LazyExcalidrawComponent;
    }

    isExcalidrawPreloaded() {
        return this.isPreloaded && this.preloadedComponent !== null;
    }

    getPreloadedComponent() {
        return this.preloadedComponent;
    }

    async getExcalidrawComponent() {
        if (this.isPreloaded && this.preloadedComponent) {
            return this.preloadedComponent;
        }

        if (this.preloadPromise !== null) {
            return this.preloadPromise;
        }

        const { default: LazyExcalidrawComponent, exportToCanvas, serializeAsJSON, languages, defaultLang } = await import(
            /* webpackChunkName: "lazy-excalidraw" */
            '../components/question/LazyExcalidrawComponent'
        );

        this.preloadedExportToCanvas = exportToCanvas;
        this.preloadedSerializeAsJSON = serializeAsJSON;
        this.preloadedLanguages = languages;
        this.preloadedDefaultLang = defaultLang;
        return LazyExcalidrawComponent;
    }

    getExportToCanvas() {
        return this.preloadedExportToCanvas;
    }

    getSerializeAsJSON() {
        return this.preloadedSerializeAsJSON;
    }

    getLanguages() {
        return this.preloadedLanguages;
    }

    getDefaultLang() {
        return this.preloadedDefaultLang;
    }

    reset() {
        this.isPreloaded = false;
        this.preloadPromise = null;
        this.preloadedComponent = null;
        this.preloadedExportToCanvas = null;
        this.preloadedSerializeAsJSON = null;
        this.preloadedLanguages = null;
        this.preloadedDefaultLang = null;
    }
}

const excalidrawPreloadService = new ExcalidrawPreloadService();
export default excalidrawPreloadService;
